import { h, JSX } from 'preact';

import { Checkbox, CheckboxProps } from './Checkbox';
import { Stack } from './Stack';
import { TextArea, TextAreaProps } from './TextArea';
import { TextField, TextFieldProps } from './TextField';

export interface CustomerSectionProps {
    sendEmail: CheckboxProps;
    name: TextFieldProps;
    email: TextFieldProps;
    phone: TextFieldProps;
    internalNote: TextAreaProps;
}

export const CustomerSection = (props: CustomerSectionProps): JSX.Element => (
    <Stack direction="column">
        <Checkbox {...props.sendEmail} />
        <TextField {...props.name} />
        <TextField {...props.email} />
        <TextField {...props.phone} />
        <TextArea {...props.internalNote} />
    </Stack>
);
